import React from 'react'
import PropTypes from 'prop-types'
import { TextArea } from 'semantic-ui-react'
import { StyledFormField, CharacterCount } from './FormTextArea.styled'
import { FormFieldError } from '../FormFieldError/FormFieldError'

/**
 * FormTextArea View Component
 * Pure presentation component for textarea fields
 */
export const FormTextAreaView = ({
  label,
  placeholder,
  required,
  disabled,
  rows,
  maxLength,
  fluid,
  error,
  errorMessage,
  value,
  onChange,
  onBlur,
  name,
  textAreaRef,
  'data-testid': dataTestId,
  'data-automation-id': dataAutomationId,
}) => {
  return (
    <>
      <FormFieldError error={errorMessage} show={error} />
      <StyledFormField
        error={error || undefined}
        required={required || undefined}
        disabled={disabled || undefined}
      >
        {label && <label>{label}</label>}
        <TextArea
          name={name}
          value={value ?? ''}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          rows={rows}
          maxLength={maxLength}
          ref={textAreaRef}
          style={{ width: fluid ? '100%' : undefined }}
          data-testid={dataTestId}
          data-automation-id={dataAutomationId}
        />
        {maxLength && (
          <CharacterCount>
            {value?.length || 0} / {maxLength}
          </CharacterCount>
        )}
      </StyledFormField>
    </>
  )
}

FormTextAreaView.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  rows: PropTypes.number,
  maxLength: PropTypes.number,
  fluid: PropTypes.bool,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  textAreaRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  'data-testid': PropTypes.string,
  'data-automation-id': PropTypes.string,
}

FormTextAreaView.defaultProps = {
  fluid: true,
  disabled: false,
  required: false,
  rows: 3,
}
